import React from 'react';

const LETTERS = ['B', 'u', 'u', 'r', 't', 'b', 'l', 'i', 'j'];
const DELAYS = ['-0.88s', '-0.77s', '-0.66s', '-0.55s', '-0.44s', '-0.33s', '-0.22s', '-0.11s', '0s'];

export default function Loader() {
    return (
        <div class="main-loader">
            <svg
                viewBox="0 0 500 120"
                width="500"
                height="120"
                preserveAspectRatio="xMidYMid"
                style={{display: 'block'}}
            >
                <text
                    x="250"
                    y="85"
                    textAnchor="middle"
                    style={{fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: '80px', fill: '#fff'}}
                >
                    {LETTERS.map((ch, i) => (
                        <tspan
                            key={i}
                            style={{
                                transformBox: 'fill-box',
                                transformOrigin: 'center',
                                animation: `1s linear ${DELAYS[i]} infinite normal forwards running animate-cnm5ie3c5cs`,
                            }}
                        >
                            {ch}
                        </tspan>
                    ))}
                </text>
            </svg>
        </div>
    );
}
